module.exports = __webpack_public_path__ + "static/media/c.6d0000a6.svg";